import { gql } from '@apollo/client';

export const ACTIVE_OTPS_QUERY = gql`
  query ActiveOtps($action: OtpAction, $limit: Int) {
    activeOtps(action: $action, limit: $limit) {
      id
      action_type
      status
      expires_at
      created_at
      created_by
    }
  }
`;

export const LOAD_OTP_PACK_MUTATION = gql`
  mutation LoadOtpPack($input: LoadOtpPackInputGql!) {
    loadOtpPack(input: $input) {
      inserted
      duplicates
    }
  }
`;

export const REVOKE_OTP_MUTATION = gql`
  mutation RevokeOtp($otp_id: ID!) {
    revokeOtp(otp_id: $otp_id) {
      id
      status
    }
  }
`;
